import { createContext, useState } from "react";
import api from "../services/api";


export const AuthContext = createContext({})

export const AuthProvider = ({children}) => {

    const [user, setUser] = useState(null)
    const [permissaoListaFuncionalidade, setPermissaoListaFuncionalidade] = useState([])
    const [permissaoUsuario, setPermissaoUsuario] = useState([])

    
    const signIn =  (json) => {
        let token = json.token
        let _user = json.user
        let _permissao_lista_funcionalidade = json.permissao_lista_funcionalidade
        let _permissao_usuario = json.permissao_usuario
        api.defaults.headers.common.Authorization = `Bearer ${token}`;
        

        let data = {
            user: _user,
            token: token,
            permissao_lista_funcionalidade: _permissao_lista_funcionalidade,
            permissao_usuario: _permissao_usuario
        }
        
        localStorage.setItem('paloGestor@data',JSON.stringify(data));
        setUser(_user)
        setPermissaoListaFuncionalidade(_permissao_lista_funcionalidade)
        setPermissaoUsuario(_permissao_usuario)
    }

    const signOut = () => {
        api.defaults.headers.common.Authorization = `Bearer `;
        // Remove sessão, filtros e preferências de todos os usuários deste app.
        // O prefixo evita apagar dados de outros sistemas no mesmo navegador.
        Object.keys(localStorage)
            .filter((chave) => chave.startsWith('paloGestor@'))
            .forEach((chave) => localStorage.removeItem(chave));
        setUser(null)
        setPermissaoListaFuncionalidade([])
        setPermissaoUsuario([])
    }

    const atualizaPermissaoUsuario = (permissao_usuario) => {
        setPermissaoUsuario(permissao_usuario)
    }

    const hasPermissao = (app, funcionalidade, tela, acao) => {
        const permissao = permissaoUsuario.filter(p => p[0].toUpperCase()===app.toUpperCase() && p[1].toUpperCase()===funcionalidade.toUpperCase() && p[2]===tela &&(acao === null || p[3] === acao)).length > 0;
        return permissao;
    }

    return (
        <AuthContext.Provider
            value={{
                user: {value:user, set: setUser},
                permissaoListaFuncionalidade: {value:permissaoListaFuncionalidade, set: setPermissaoListaFuncionalidade},
                permissaoUsuario: {value:permissaoUsuario, set: hasPermissao},
                signIn, 
                signOut,
                atualizaPermissaoUsuario
            }}
        >
            {children}
        </AuthContext.Provider>
    )
}
